import { TextStyle } from "../../drawing/TextStyle";

export interface ITextDrawable {
  textStyle: TextStyle;
  text(): string;
}

export function instanceOfITextDrawable(instance: any): instance is ITextDrawable {
  return instance
    && (instance.textStyle !== undefined)
    && (instance.text !== undefined);
}
